import React, { Component } from "react";
import api from "../../api";
import { Button } from "primereact/button";

const FileDownload = require('js-file-download');

class MembershipReport extends Component {
  constructor() {
    super();
    this.state = {
      startDate: '',
      endDate: ''
    };
    this.getStopOrders = this.getStopOrders.bind(this);
  }

  componentDidMount() {

  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  getStopOrders() {
    const { startDate, endDate } = this.state;


    const url = "/api/download-recruitment-schedule/" + startDate + "/" + endDate;

    api.get(url, { responseType: 'blob' }).then((response) => {
      //const data = response.data;

      //Create a Blob from the PDF Stream
      // const file = new Blob(
      //   [response.data]
      //   , { type: 'application/csv' });
      FileDownload(response.data, 'stop-orders.csv');
      //Build a URL from the file
      //const fileURL = URL.createObjectURL(file);

      //Open the URL on new Window
      //window.open(fileURL);
      alert("Download completed!")

    }).catch(
      function (error) {
        console.log(error)
        alert('An Error occrured please try again')
      }
    );

  }

  render() {


    return (
      <div className="col-sm-6">
        <div className="card mt-4 border-primary shadow-lg rounded p-3">
          <div className='card-header mb-3 '>
            <h5 className="m-auto">View Recruitments</h5>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <label>Start Date</label>
              <input
                type="date"
                required
                className="form-control"
                name="startDate"
                onChange={this.onChange}
                value={this.state.startDate || ""}
              />
            </div>
            <div className="col-sm-4">
              <label>End Date</label>
              <input
                type="date"
                required
                className="form-control "
                name="endDate"
                onChange={this.onChange}
                value={this.state.endDate || ""}
              />
            </div>
            <div className="col-sm-4 d-flex justify-content-bottom">

              <Button

                type="button"
                icon="pi pi-external-link"
                label="Download Schedule"
                onClick={this.getStopOrders}
              ></Button>
            </div>
          </div>
          <div className="card-footer">

           
          </div>
        </div>
      </div>



    );
  }
}

export default MembershipReport;
